module.exports = __webpack_public_path__ + "r-v3/img/flag.fa7c6aff.svg";